import { Injectable } from '@angular/core';
import { FormKeys } from '@nx-customer-apps/shared/enums';
import { EnergySourceOptions, RadioQuestionOverride } from '@nx-customer-apps/shared/interfaces';
import { RadioQuestion } from '@nx-customer-apps/shared/utils';
import { CommonFormService } from '../../../../services/common-form.service';

@Injectable({
    providedIn: 'root'
})
export class EnergySourceFormService {
    constructor(private commonFormService: CommonFormService) {}

    /**
     * Returns Energy Source and Required Energy Per Year questions configs if they are specified in options.
     */
    public getEnergySourceQuestions(options?: EnergySourceOptions): RadioQuestion[] {
        const heatGeneratorOverride = options?.questions?.[FormKeys.HeatGenerator] as RadioQuestionOverride;
        if (!heatGeneratorOverride?.options) {
            throw Error('Provide option keys for heat generator question');
        }
        const heatGenerator = this.commonFormService.getHeatGenerator(heatGeneratorOverride, {
            heatGeneratorDictionary: options?.heatGeneratorDictionary
        });
        if (heatGeneratorOverride) {
            heatGenerator.value = heatGeneratorOverride.value;
        }
        const questions: RadioQuestion[] = [heatGenerator];
        const specificEnergySourceOveride = options?.questions?.[FormKeys.EnergySource] as RadioQuestionOverride;

        if (specificEnergySourceOveride?.options) {
            const specificEnergySource = this.commonFormService.getSpecificEnergySource(specificEnergySourceOveride);
            specificEnergySource.value = specificEnergySourceOveride.value;
            questions.push(specificEnergySource);
        }
        return questions;
    }
}
